import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightshipInspectionStatusMarker } from "./../rightship-inspection-status-marker";


import Quill from "quill";
window["Quill"] = Quill;
if (!Quill["imports"]['formats/rightship-inspection-status-marker']) {
    Quill.register({
        'formats/rightship-inspection-status-marker': RightshipInspectionStatusMarker
    });
}


@autoinject
@transient()
export class RightshipInspectionCommentDialog {
    fullComment: any | string;

    constructor(private dialogClientService: DialogClientService) {
        
    }

    async activate(model: any) {
        if (!model) return;     

        this.fullComment = model.fullComment;
    }

    cancel() {
        this.dialogClientService.hide();
    }
}
